<template>
    <a-config-provider :locale="locale">
        <div id="app">
            <router-view/>
            <div class="full-icon" @click="onSwitchFull">
                <a-icon :type="!full ? 'fullscreen' : 'fullscreen-exit'" fill="#fff"/>
            </div>
        </div>
    </a-config-provider>
</template>

<script>
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

    export default {
        mounted() {
            this.full = document.fullscreen;
            document.onfullscreenchange = e => {
                this.full = document.fullscreen;
            }
        },
        data() {
            return {
                full: false,
                locale: zhCN
            }
        },
        methods: {
            // 是否全屏的切换
            onSwitchFull() {
                if (this.full) {
                    document.exitFullscreen();
                    return;
                }
                document.documentElement.requestFullscreen();
            }
        }
    }
</script>

<style lang="scss">
    @import './style/main.scss';
    @font-face {
        font-family: dakai;
        src: url("./style/Alimama_DongFangDaKai_Regular.ttf");
    }

    #app {
        height: 100vh;
        width: 100vw;
        overflow: hidden;
        .full-icon {
            color: #fff;
            position: fixed;
            bottom: 30px;
            right: 30px;
            cursor: pointer;
            font-size: 48px;
        }
    }
</style>